export default __webpack_public_path__ + "static/up_down_b.f98844ed023783ad1a3b38c5395e9ee7.svg";